import diff from 'deep-diff';
import PropTypes from 'prop-types';
import React from 'react';
import Editor from '../../../../common/EditorPlus/EditorPlus.container';

const paddings = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

const pluginConfig = {
  addBlock: { inverted: true },
  textFormatter: { verticalOffset: 30 },
};

class WriteZone extends React.PureComponent {
  constructor(props) {
    super(props);
    this.editor = null;
    this.onChange = this.onChange.bind(this);
    this.setEditor = this.setEditor.bind(this);

    this.lastContentOfEditor = null;
  }

  onChange(event) {
    const js = event.toJS();
    if (js.lastChangeType !== null && js.currentContent) {
      const contentDiff = diff(
        js.currentContent,
        this.lastContentOfEditor || {}
      );
      if (contentDiff !== undefined) {
        this.lastContentOfEditor = js.currentContent;
      }
    }

    const { onChange } = this.props;
    onChange(js.currentContent);
  }

  setEditor(value) {
    this.editor = value;
  }

  export() {
    return this.editor.export();
  }

  render() {
    const { initialContent } = this.props;

    return (
      <Editor
        initialEditorState={JSON.parse(initialContent)}
        wrappedRef={this.setEditor}
        paddings={paddings}
        pluginsConfigs={pluginConfig}
        type="inbox"
        onChange={this.onChange}
        maxEditorHeight="70vh"
        focusAfterClear
      />
    );
  }
}

WriteZone.propTypes = {
  initialContent: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WriteZone;
